var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-container lg:px-0 lg:mx-auto flex gap-8 px-6 -mx-6 overflow-auto"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }